/* 支払方法区分 */
export default {
    // 銀行振込
    BANK_TRANSFER: "10",
    // クレジット払い
    CREDIT_CARD: "20",
    // コンビニ払い
    CONVENIENCE_STORE: "30",
    // ロッピー
    LOPPI: "40",
    // ファミポート決済
    FAMI_PORT: "41",
    // ベネポ払い
    BENEPO: "50",
    // カフェテリアポイント＋ベネポ払い
    CAFE_POINT_AND_BENEPO: "55",
    // カフェテリアポイント払い
    CAFE_POINT: "60",
    // 全額補助金
    SUBSIDY: "61",
    // 給トク払い
    KYUTOKU: "70"
}